import React, { useEffect, createElement } from 'react';
import AdvertorialGlpAdv1 from '../components/AdvertorialGlpAdv1';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpAdv1Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking - NEW CUSTOM EVENTS
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18443">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18444">
        <Helmet data-id="element-18445">
          <title data-id="element-18446">
            Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users
            Experiencing Severe Depression—And Why Isn't Anyone Talking About
            It?
          </title>
          <meta property="og:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-18447" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18448" />
          <meta property="og:type" content="article" data-id="element-18449" />
          <meta property="og:url" content={window.location.href} data-id="element-18450" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18451" />
          <meta property="og:image:width" content="1200" data-id="element-18452" />
          <meta property="og:image:height" content="630" data-id="element-18453" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18454" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18455" />
          <meta name="twitter:title" content="Endocrinologist Investigates: Why Are 1 in 10 Ozempic Users Experiencing Severe Depression—And Why Isn't Anyone Talking About It?" data-id="element-18456" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18457" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18458" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18459" />
        </Helmet>
        <AdvertorialGlpAdv1 data-id="element-18460" />
      </div>
    </HelmetProvider>;
}